import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickTakeaways = ({ takeaways }) => {
  if (!takeaways?.length) return null;

  return (
    <div className="bg-gradient-to-br from-primary-50 to-secondary-50 rounded-2xl p-6 border border-primary-100">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Lightbulb" size={20} className="text-primary" />
        <h3 className="font-heading font-semibold text-lg text-accent-800">
          Quick Takeaways
        </h3>
      </div>
      
      <ul className="space-y-3">
        {takeaways.map((takeaway, index) => (
          <li key={index} className="flex items-start space-x-3">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <Icon name="Check" size={14} className="text-white" />
            </div>
            <span className="text-sm text-accent-700 leading-relaxed">
              {takeaway}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickTakeaways;